import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

enum TYPE_ERROR {
	required = 'required',
	maxlength = 'maxlength',
	email = 'email',
	aceptedTerms = 'isAceptedTerms',
	validPassword = 'isValidPassword',
	pattern = 'pattern',
	dateInitInvalid = 'dateInitInvalidRange',
	dateEndInvalid = 'dateEndInvalidRange',
}
export abstract class FormBase {
	abstract form: FormGroup;
	formSubmitted: boolean = false;

	formControl(name: string) {
		return this.form.controls[name];
	}

	getErrors(name: string): string[] {
		const control = this.formControl(name);
		return Object.keys(control?.errors || {});
	}

  getKeysForm(key: string){
    let errors = this.form.errors ||  {}
    let isExistkey = Object.keys(errors).includes(key);

    return isExistkey ?  Object.keys(errors).find(item => item === key) : '';
  }

	hasError(name: string) {
		const control = this.formControl(name);
		if (control.touched) {
			return this.getErrors(name).length > 0;
		} else {
			return this.getErrors(name).length > 0 && this.formSubmitted;
		}
	}

	hasErrorForm(name: string) {
		const error = this.getKeysForm(name);
    return error ? true : false;
	}

	getErrorMessages(name: string): string[] {
		return this.getErrors(name).map((x) => {
      return this.switchErrors(x);
		});
	}

  switchErrors(value: string){
    switch (value) {
      case TYPE_ERROR.required:
        return `Campo requerido`;
      case TYPE_ERROR.maxlength:
        return `Longitud del campo excedida`;
      case TYPE_ERROR.email:
        return `Correo inválido`;
      case TYPE_ERROR.pattern:
        return `No cumple con el formato`;
      case TYPE_ERROR.aceptedTerms:
        return `Debe aceptar los términos y condiciones`;
      case TYPE_ERROR.validPassword:
        return `Las contraseñas deben ser iguales`;
      case TYPE_ERROR.dateInitInvalid:
        return `La fecha inicio no es válida`;
      case TYPE_ERROR.dateEndInvalid:
        return `La fecha final no es válida`;
      default:
        console.log(value);
        return 'Error';
    }
  }

	getFirstErrorMessage(name: string): string {
		return this.getErrorMessages(name)[0] || '';
	}

	getFirstErrorMessageForm(key: string): string {
    let keyExist = this.getKeysForm(key);
   return keyExist ? this.switchErrors(keyExist || '') : '';
	}

	hasRequiredError(name: string) {
		const control = this.formControl(name);
		if (control.touched) {
			return control.getError('required');
		} else {
			return control.getError('required') && this.formSubmitted;
		}
	}

	getFile($event: Event): File {
		const target = $event.target as HTMLInputElement;
		const files = target.files as FileList;
		return files[0];
	}
}

export abstract class FormArrayBase {
	abstract form: FormGroup;
	formSubmitted: boolean = false;

	formControlArray(index: number, nameArray: string, name: string): AbstractControl {
		const formArray = this.form.controls[nameArray] as FormArray;
		const form = formArray.controls.at(index) as FormGroup;
		return form.controls[name];
	}

	getErrors(index: number, nameArray: string, name: string): string[] {
		const control = this.formControlArray(index, nameArray, name);
		return Object.keys(control?.errors || {});
	}

	hasError(index: number, nameArray: string, name: string) {
		const control = this.formControlArray(index, nameArray, name);
		if (control.touched) {
			return this.getErrors(index, nameArray, name).length > 0;
		} else {
			return this.getErrors(index, nameArray, name).length > 0 && this.formSubmitted;
		}
	}

	getErrorMessages(index: number, nameArray: string, name: string): string[] {
		return this.getErrors(index, nameArray, name).map((x) => {
			switch (x) {
				case TYPE_ERROR.required:
					return `Campo requerido`;
				case TYPE_ERROR.maxlength:
					return `Longitud del campo excedido`;
				case TYPE_ERROR.email:
					return `Correo inválido`;
				default:
					console.log(x);
					return 'Error';
			}
		});
	}

	getFirstErrorMessage(index: number, nameArray: string, name: string): string {
		return this.getErrorMessages(index, nameArray, name)[0] || '';
	}

	hasRequiredError(index: number, nameArray: string, name: string) {
		const control = this.formControlArray(index, nameArray, name);
		if (control.touched) {
			return control.getError('required');
		} else {
			return control.getError('required') && this.formSubmitted;
		}
	}

	getFile($event: Event): File {
		const target = $event.target as HTMLInputElement;
		const files = target.files as FileList;
		return files[0];
	}
}
